export const SHOW_BET_PROMPT_AFTER_DAYS = 14;
export const SHOW_DESKTOP_PROMPT_AFTER_DAYS = 30;
export const SHOW_MOBILE_PROMPT_AFTER_DAYS = 21;
